import { AudioManager, ITrack, Track } from "../../AudioManager";
import { ISystemContext } from "../../Context/SystemContext";
import { LogGroup, Size, Scale, Log, Safe, Get } from "../../MyHelpers";
import { DecodedImageResource, ImageResource } from "../../ResourceManager/ImageResource";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../ResourceManager/SpriteResource";
import { Settings, JackpotDisplayType } from "../../Settings";
import { ZIndex } from "../../ZIndex";
import { SpinAndHoldParams } from "../Bonus/SpinAndHold/SpinAndHoldParams";
import { CanvasSprite } from "../Sprite/CanvasSprite";
import { ITransition } from "./ITransition";
import { ITransitionParams  } from "./ITransitionFactory";
import { TweenMax } from "gsap";
import { ITransitionParamsPIXIAPP } from "./ITransitionFactoryPIXIAPP";
import { JackpotDisplayProperties } from "../../JackpotDisplayProperties";
import * as PIXI from 'pixi.js'
import { IInterval } from "../../Context/Interval";
import { FixedSizeFitContainer, ResponsiveSizeContainer, ResponsiveView } from "../../../singlegame/ResponsiveHelpers";
import { GetOrientation, Orientation } from "../../FitScreen";

export class ImageTransition implements ITransition {
    //protected systemContext: ISystemContext = null;
    protected params: ITransitionParams = null;

    protected view: HTMLElement = null;
    //protected audio: AudioManager = null;
    protected resid: ResourceIdentifier = null;
    //protected logGroup: LogGroup = null;
    protected gameName: string = null;
    protected backgroundTransitionView: HTMLElement = null;
    protected PathGame: string = null;
    protected spriteResource: SpriteResource = null;    
    protected imgResource : ImageResource;
    protected track : ITrack ; 
    protected TitleSpriteTransition : CanvasSprite = null;
    

    public onTransitionStart: () => void = null;
    public onTransitionEnd: () => void = null;

    public constructor(params : ITransitionParams) {
        this.params = params;
        this.resid = params.resid;
        this.gameName = params.gameName;
        this.imgResource = params.imgResource;
        this.spriteResource = params.spriteResource;
        this.resid = params.resid;
        this.track = params.soundResource;

        


        this.view = document.createElement("div");
        this.view.classList.add(this.resid.Scope());
        this.view.classList.add(params.gameName + "-TransitionSpinHold");
        this.view.style.position = "absolute";
        this.view.style.width = "100%";
        this.view.style.height = "100%";
        this.view.style.top = Scale.Xpx(0);
        //this.PathGame = Settings.ResourcesFolder + "multigame/slot/" + params.gameName + "/resources/"

    }
    CreateTransitionPixi(appView: PIXI.Container) {
        throw new Error("Method not implemented.");
    }
    DestroyTransitionPixi() {
        throw new Error("Method not implemented.");
    }
    OnResize(): void {
        throw new Error("Method not implemented.");
    }

    public async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
        //this.PrepareTitleTransition(resourceManager)
        //this.PrepareImgTransition(resourceManager)
    };
    public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {

        this.LoadTitleTransition(resourceManager);
        this.LoadImgTransition(resourceManager);
    };

    public PrepareImgTransition(resourceManager: ResourceManager) {
       // resourceManager.Add(new ImageResource(this.PathGame + "BackgroundTransition_3S.png", this.resid.ScopedResourceName([this.gameName+"BackgroundTransition", "image"])));
    }



  

    public LoadTitleTransition(resourceManager: IReadOnlyResourceManager): void {

        this.TitleSpriteTransition = new CanvasSprite({sprite: this.spriteResource.sprite.Copy(), canvasSize: new Size(Scale.W(1920), Scale.H(1080))});
        this.TitleSpriteTransition.View().style.position = "absolute";
        if ( Settings.Screens >= 2){
            //this.TitleSpriteTransition.View().style.position = "relative";
            this.TitleSpriteTransition.View().style.top = Scale.Ypx(-959);
        }
        else {
            this.TitleSpriteTransition.View().style.top = Scale.Ypx(0);
        }

        this.TitleSpriteTransition.View().style.visibility = "hidden";
       
        //this.TitleSpriteTransition.View().style.left="60px";
        this.TitleSpriteTransition.View().style.zIndex = ZIndex.BonusTransitionTitle.toString();
        //this.TitleSpriteTransition.View().style.display="none";
        this.TitleSpriteTransition.View().classList.add("TitleDiamondPot-StickySpin");
        //this.TitleSpriteTransition.AddOnStartCallback(() => { this.params.audio.Play(this.resid.ScopedResourceName("transitionLight")); })
        this.TitleSpriteTransition.AddOnStartCallback(() => { this.track.Play() })
        this.view.appendChild(this.TitleSpriteTransition.View());
    }

    public LoadImgTransition(resourceManager : IReadOnlyResourceManager) {

        this.backgroundTransitionView = document.createElement("div");
		this.backgroundTransitionView.classList.add("TransitionSpinAndHold");
		this.backgroundTransitionView.style.height=Scale.Hpx(1080* Settings.Screens) ;
		this.backgroundTransitionView.style.width=Scale.Wpx(1920);
		//this.backgroundTransitionView.style.background="black";
		this.backgroundTransitionView.style.display="none";
		this.backgroundTransitionView.style.position="absolute";
		this.backgroundTransitionView.style.bottom=Scale.Ypx(0);
		
		this.backgroundTransitionView.style.zIndex=ZIndex.BonusTransition.toString();
		this.backgroundTransitionView.style.backgroundImage= this.imgResource.CssBackground(),
		//this.backgroundTransitionView.appendChild(this.TitleSpriteTransition.View());
		this.backgroundTransitionView.style.backgroundSize="auto";
        this.backgroundTransitionView.style.backgroundPosition = "center";
        this.backgroundTransitionView.style
		this.view.appendChild(this.backgroundTransitionView);

    }



    protected started: boolean = false;
    public ShowTransiton(): void {

        if (this.started == false) {
            this.started = true;
            // Log.Debug(this.params.logGroup, "Start transition");
            this.OnTransitionStarted();
            TweenMax.set(this.backgroundTransitionView, { autoAlpha: 1, display: "" });

            //this.TitleSpriteTransition.View().style.visibility = "visible";
            //this.backgroundTransitionView.style.visibility = "visible";
            //this.backgroundTransitionView.style.display = "";

            this.onTransitionStart?.();

            // fadeout
            setTimeout(() =>
                TweenMax.to(this.backgroundTransitionView, 2, {
                    autoAlpha: 0, onComplete: () => {
                        //video.StopAndReset(this.resid);
                        //video.Hide();
                        //this.backgroundTransitionView.style.display = "none";
                        this.backgroundTransitionView.style.display = "none";

                        this.OnTransitionEnded();
                    }
                }
                ), 2000);


            setTimeout(() =>
                TweenMax.fromTo(this.TitleSpriteTransition.View(), 0.5, {
                    autoAlpha: 0, display: "none"
                }, { autoAlpha: 1, display: "block", onComplete: () => { this.TitleSpriteTransition.Start(false); } }
                ), 500);



            setTimeout(() =>
                TweenMax.to(this.TitleSpriteTransition.View(), 1, { autoAlpha: 0, display: "none" }
                ), 2000);



        }
    };
  
    public View(): HTMLElement {
        return this.view
     };



    public OnTransitionStarted() {
        // Log.Debug(this.params.logGroup, "Transition started");
        this.onTransitionStart?.();
    }

    public OnTransitionEnded(): void {
        // Log.Debug(this.params.logGroup, "Transition ended");
        this.started = false;
        this.onTransitionEnd?.();
    }

    public Update():void
    {
        this.TitleSpriteTransition.Update();
    }

}